export const SET_STATUSES = 'SET_STATUSES'
export const SET_REQUESTS = 'SET_REQUESTS'
export const SET_TOOLS = 'SET_TOOLS'
export const SET_TECHS = 'SET_TECHS'
export const SET_USERINFO = 'SET_USERINFO'



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/types.js